import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import setAxiosInterceptor from '@/services/axiosInteceptor.ts/axiosInterceptor';
import BaseErrorHandler from '@/services/errorHandler/baseErrorHandler/BaseErrorHandler';
import { Store } from 'vuex';
import { RootState } from '@/store/types';
import { Header } from '@/repositories/fo-manual-API/IEntityRepository';

const baseDomain = process.env.VUE_APP_API_URL;
const baseURL = `${baseDomain}/api`;
const headers: Header = {};
const errorHandler = new BaseErrorHandler();

const axiosConfig: AxiosRequestConfig = {
  baseURL,
  headers,
};

export const axiosInstance: AxiosInstance = axios.create(axiosConfig);

const initRepository = (store: Store<RootState>) => {
  setAxiosInterceptor(store, axiosInstance, errorHandler);
  return axiosInstance;
};

export default initRepository;
